/**
 * Safe version of window.matchMedia that returns a stub result when window
 * is not available during SSR.
 * @link https://developer.mozilla.org/docs/Web/API/Window/matchMedia
 */
export const matchMediaSafe: Window['matchMedia'] = (query) => {
	if (typeof window === typeof undefined) {
		return {
			addEventListener: () => {},
			addListener: () => {},
			dispatchEvent: () => false,
			matches: false,
			media: query,
			onchange: () => {},
			removeListener: () => {},
			removeEventListener: () => {},
		};
	}

	return window.matchMedia(query);
};
